"use client";

import useSWR from "swr";
import { fetcher } from "@aprosoja/api";
import { CategoryType, GetNewsData } from "@aprosoja/types";
import { useMemo, useState } from "react";

const useCategory = (slug: string) => {
  const [pageLimit, setPageLimit] = useState(5);

  const { data: categoryData, isLoading: categoryDataIsLoading } =
    useSWR<CategoryType>(
      slug ? `/categories/findBySlug/${slug}` : null,
      fetcher,
      {
        revalidateOnMount: true,
        revalidateOnFocus: false,
      }
    );

  const categoryId = categoryData?.id;

  const { data: newsData, isLoading: newsDataIsLoading } = useSWR<GetNewsData>(
    categoryId
      ? `/news?status=true&categoryId=${categoryId}&limit=${pageLimit}`
      : null,
    fetcher,
    {
      revalidateOnMount: true,
      revalidateOnFocus: false,
    }
  );

  const orderedNews = useMemo(() => {
    return (
      newsData?.data?.sort((a, b) => {
        return (
          new Date(b.createdAt as string).getTime() -
          new Date(a.createdAt as string).getTime()
        );
      }) ?? []
    );
  }, [newsData]);

  const firstRecentNews = orderedNews.slice(0, 1);
  const remainingRecentNews = orderedNews.slice(1);

  const loadMore = () => {
    setPageLimit((prev) => prev + 4);
  };

  return {
    newsData,
    pageLimit,
    loadMore,
    categoryData,
    firstRecentNews,
    remainingRecentNews,
    newsDataIsLoading,
    categoryDataIsLoading,
  };
};

export default useCategory;
